@if (visible() && cards().length > 0) {
  <div class="hd-cycle-cards" data-test-id="cycle-cards">
    @for (card of cards(); track card.slot.anchorId) {
      @if (card.slot.first) {
        @if (card.lineVm; as lineVm) {
          <div class="hd-cycle-cards__card"
               [class.hd-cycle-cards__card--chart]="card.slot.source.origin === 'chart'"
               [attr.data-card-id]="card.slot.anchorId">
            <hd-gate-line [viewModel]="lineVm" />
          </div>
        }
      } @else {
        <!-- Dezelfde activatie kreeg al hoger een kaart: verwijzing i.p.v. herhaling. -->
        <button
          type="button"
          class="hd-cycle-cards__see-above"
          [title]="card.seeAboveTooltip"
          data-test-id="cycle-cards-see-above"
          (click)="onReferenceClick(card.slot.anchorId)"
        >
          <span class="hd-cycle-cards__see-above-glyph" aria-hidden="true">{{ card.slot.source.glyph }}</span>
          <span class="hd-cycle-cards__see-above-planet">{{ card.planetName }}</span>
          <i class="fas fa-arrow-turn-up hd-cycle-cards__see-above-icon" aria-hidden="true"></i>
          <span>{{ card.seeAboveLabel }}</span>
        </button>
      }
    }
  </div>
}
